import React from 'react'
import {
  Box,
  Button,
  LinearProgress,
  useMediaQuery,
  useTheme,
  SvgIcon,
} from '@mui/material'

import AppBar from './AppBar'
import Drawer from './Drawer'
import MobileDrawer from './MobileDrawer'
import Main from './Main'
import UserService from 'api/services/User'
import KeycloakService from 'services/KeycloakService'
import { useAuthStore, useDrawerStore } from 'store'
import { ReactComponent as BurgerClosedSVG } from 'assets/svg/new-icons/closedmenu.svg'

const drawerWidth = 272

const TOP_MARGIN_MD = '78px'
const TOP_MARGIN_SM = '69px'

const barWidth = 0
const Dashboard: React.FC = (props) => {
  const [open, toggleOpen, setOpen] = useDrawerStore((state) => [
    state.open,
    state.toggleOpen,
    state.setOpen,
  ])

  const [setUser] = useAuthStore((state) => [state.setUser])

  const toggleDrawer = () => {
    toggleOpen(open)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }
  const theme = useTheme()

  const SMALL_SCREEN = useMediaQuery(theme.breakpoints.down(900))
  React.useEffect(() => {
    if (SMALL_SCREEN) {
      handleDrawerClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SMALL_SCREEN])
  const currentUser = UserService.hooks.useCurrentUser({
    enabled: !!KeycloakService.isLoggedIn(),
    onSuccess: (data) => {
      setUser(data)
    },
  })
  if (currentUser.isLoading) {
    return <LinearProgress />
  }

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: 'common.white',
      }}
    >
      <AppBar
        open={open}
        onOpen={toggleDrawer}
        onClose={handleDrawerClose}
        width={barWidth}
      />
      {SMALL_SCREEN && !open ? (
        <Box>
          <Button
            onClick={toggleDrawer}
            sx={{
              position: 'fixed',
              top: { xs: TOP_MARGIN_SM, sm: TOP_MARGIN_MD, lg: '128px' },
              zIndex: 1203,
              bgcolor: 'common.white',
              minWidth: '49px',
              height: '49px',
              borderRadius: '12px',

              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              boxShadow: '3px 3px 8px rgba(9, 9, 9, 0.3)',
              '&:hover': {
                bgcolor: 'common.white',
              },
            }}
          >
            <SvgIcon component={BurgerClosedSVG} inheritViewBox />
          </Button>
        </Box>
      ) : null}
      {!SMALL_SCREEN ? (
        <Drawer
          open={open}
          onOpen={toggleDrawer}
          onClose={handleDrawerClose}
          width={drawerWidth}
          TOP_MARGIN_SM={TOP_MARGIN_SM}
          TOP_MARGIN_MD={TOP_MARGIN_MD}
        />
      ) : null}
      {SMALL_SCREEN && open ? (
        <MobileDrawer
          width={236}
          TOP_MARGIN_SM={TOP_MARGIN_SM}
          TOP_MARGIN_MD={TOP_MARGIN_MD}
        />
      ) : null}
      <Main TOP_MARGIN_SM={TOP_MARGIN_SM} TOP_MARGIN_MD={TOP_MARGIN_MD} />
    </Box>
  )
}

export default Dashboard
